import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const stripHtml = (html) => {
  if (!html) return '';
  // Decode HTML entities via temporary DOM element + strip tags
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
};

export default function Haberler() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/news`);
      const data = await response.json();
      setNews(data);
    } catch (error) {
      toast.error('Haberler yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center">
        <div className="text-xl text-amber-800">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Haberler
          </h1>
          <p className="text-lg text-amber-700">
            Derneğimizden son haberler ve gelişmeler
          </p>
        </div>

        {news.length === 0 ? (
          <Card className="border-2 border-amber-200 bg-white">
            <CardContent className="p-12 text-center">
              <p className="text-lg text-amber-700">Henüz haber yayınlanmamış</p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((item) => (
              <Card key={item.id} className="card-hover border-2 border-amber-200 bg-white overflow-hidden" data-testid={`news-card-${item.id}`}>
                {item.image_url && (
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={item.image_url} 
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <CardHeader>
                  <CardTitle className="text-amber-900" style={{ fontFamily: 'Merriweather, serif' }}>
                    {item.title}
                  </CardTitle>
                  <div className="flex items-center gap-2 text-sm text-amber-600">
                    <Calendar className="w-4 h-4" />
                    <span>{formatDate(item.created_at)}</span>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-amber-800 line-clamp-3 mb-4">{stripHtml(item.content)}</p>
                  <p className="text-sm text-orange-700 mb-4 font-semibold">
                    Yazar: {item.author}
                  </p>
                  <Link to={`/haberler/${item.id}`}>
                    <Button variant="outline" className="border-amber-300 text-amber-900 hover:bg-amber-50" data-testid={`read-more-${item.id}`}>
                      Devamını Oku
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
